import { all, takeLatest } from 'redux-saga/effects';
import {
  CREATE_GROUP,
  GET_GROUPS,
  GET_GROUP_DETAILS,
} from '../../actions/groups';
import {
  createGroupSaga,
  getAllGroupsSaga,
  getGroupDetailsSaga,
} from './getGroupsSaga';

function* groupSagas() {
  yield all([
    yield takeLatest(GET_GROUPS.INITIATE, getAllGroupsSaga),
    yield takeLatest(GET_GROUP_DETAILS.INITIATE, getGroupDetailsSaga),
    yield takeLatest(CREATE_GROUP.INITIATE, createGroupSaga),
  ]);
}

export default groupSagas;
